import type { ProjectTemplateParameterResource, ProjectTemplateParameterSetResource, ProjectTemplateResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
export type ProducerProjectTemplateContextProps = {
    localNames: string[];
    parameters: ProjectTemplateParameterResource[];
    projectTemplate: ProjectTemplateResource;
};
export const ProducerProjectTemplateContext = React.createContext<ProducerProjectTemplateContextProps | undefined>(undefined);
export const useOptionalProducerProjectTemplateContext = () => {
    return React.useContext(ProducerProjectTemplateContext);
};
export function buildProducerProjectTemplateContextProps(resource: ProjectTemplateResource, parameterSet: ProjectTemplateParameterSetResource): ProducerProjectTemplateContextProps {
    return {
        projectTemplate: resource,
        parameters: parameterSet.Parameters,
        localNames: parameterSet.Parameters.sort((a, b) => a.Name.localeCompare(b.Name)).map((p) => p.Name),
    };
}
